export const globalConfigStore = {
    size: '',
    version: 1,
    zIndex: 999,
    resizeInterval: 500
};
